/* eslint-disable */
import { Box, Button, Divider } from "@mui/material";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState, useRef, useCallback } from "react";
import styles from "./AmarantComponent.module.scss";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { listVehicles } from "../../actions/amarantFields";
import { connect } from "react-redux";
import moment from "moment";
import { filterByProp } from "../../utils/helperFunctions";
import VehicleModalComponent from "./VehicleModalComponent";
import { getPresignedUrlView } from "../../utils/files";
import ArchiveIcon from "@mui/icons-material/Archive";
import Tooltip from "@mui/material/Tooltip";

// Column headers for the vehicle table
const columnNames = [
  "amarant:colOwner",
  "amarant:colPlate",
  "amarant:colTalonNo",
  "amarant:colMake",
  "amarant:colModel",
  "amarant:colAddedOn",
  "amarant:colShared",
  "amarant:colSharedWith",
  "amarant:colPhone",
  "amarant:colSharedWith",
  "amarant:colPhone",
];

// Additional column headers
const additionalKeys = ["amarant:katData", "amarant:scannedTalon"];

function VehiclesComponent({ vehicles, listVehicles, customerID }) {
  const { t } = useTranslation();
  const [filter, setFilter] = useState("");
  const [highestNumber, setHighestNumber] = useState(0);
  const highest = useRef(0);
  const [currentVehicle, setCurrentVehicle] = useState({});
  const [lastOpenedSection, setLastOpenedSection] = useState("");
  const [openModal, setOpenModal] = useState(false);

  // Load vehicles on component mount
  useEffect(() => {
    listVehicles({
      customerSupportId: customerID,
    });
  }, []);

  // Calculate highest number of shared users
  useEffect(() => {
    vehicles.map((vehicle) => {
      if (vehicle.users.length > highest.current)
        highest.current = vehicle.users.length;
    });
    setHighestNumber(highest.current);
  }, [vehicles]);

  // Toggle arrow rotation and info section visibility
  const rotateArrow = (iconId, infoId) => {
    if (document.getElementById(infoId).offsetParent !== null) {
      document.getElementById(infoId).style.display = "none";
      document.getElementById(iconId).style.transform = "rotate(360deg)";
    } else {
      if (lastOpenedSection.length > 0) {
        document.getElementById(lastOpenedSection).style.display = "none";
        document.getElementById(
          `icon${Number(lastOpenedSection.slice(-1)) + 10}`
        ).style.transform = "rotate(360deg)";
      }
      document.getElementById(infoId).style.display = "block";
      document.getElementById(iconId).style.transform = "rotate(180deg)";
      setLastOpenedSection(infoId);
    }
  };

  // Format vehicle owner names
  const retrieveNames = (vehicle) => {
    const names = [];
    if (vehicle?.companyName?.length) names.push(vehicle?.companyName);
    if (vehicle?.fullName?.length) names.push(vehicle?.fullName);
    return names.join(" - ");
  };

  // Get and open document in new window
  const fetchAndOpenPreSignedUrl = async (file) => {
    const url = await getPresignedUrlView(file);
    window.open(url);
  };

  // Check if vehicle is archived
  const isVehicleArchived = (vehicle) => {
    if (!vehicle) return false;

    return (
      (vehicle.deletedAt !== undefined && vehicle.deletedAt !== null) ||
      vehicle.status === "archived"
    );
  };

  return (
    <div
      style={{
        width: "100%",
        height: window.innerWidth < 900 ? "120%" : "95%",
        overflowY: "auto",
      }}
    >
      {window.innerWidth < 900 ? (
        // Mobile view
        <>
          <div className={styles["tabs-container"]} style={{ padding: "0px" }}>
            {vehicles.map((vehicle, i) => {
              return (
                <div
                  className={styles["row-container"]}
                  style={{ marginTop: "5%", display: "block", height: "unset" }}
                  key={i}
                >
                  <div className={styles["mobile-box"]}>
                    <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {t(columnNames[0])}
                    </p>
                    <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {vehicle?.fullName
                        ? vehicle?.fullName
                        : vehicle?.companyName || ""}
                    </b>
                  </div>
                  <div className={styles["mobile-box"]}>
                    <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {t(columnNames[1])}
                    </p>
                    <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {vehicle?.licensePlate}
                    </b>
                  </div>
                  <Divider />
                  <div className={styles["mobile-box"]}>
                    <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {t(columnNames[2])}
                    </p>
                    <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {vehicle?.certificateRegistration}
                    </b>
                  </div>
                  <Divider />
                  <div className={styles["mobile-box"]}>
                    <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {t(columnNames[3])}
                    </p>
                    <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {vehicle?.carMakeEnglish.split(" ")[0]}
                    </b>
                  </div>
                  <Divider />
                  <div className={styles["mobile-box"]}>
                    <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {t(columnNames[4])}
                    </p>
                    <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {vehicle?.carMakeEnglish.includes(" ")
                        ? vehicle?.carMakeEnglish.slice(
                            vehicle?.carMakeEnglish.indexOf(" ") + 1
                          )
                        : vehicle?.carMakeEnglish}
                    </b>
                  </div>
                  <Divider />
                  <div className={styles["mobile-box"]}>
                    <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {t(columnNames[5])}
                    </p>
                    <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {moment(vehicle?.createdAt).format("DD.MM.YYYY | HH:mm")}
                    </b>
                  </div>
                  <Divider />
                  <div className={styles["mobile-box"]}>
                    <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {t(columnNames[6])}
                    </p>
                    <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {vehicle.users.length > 0 ? t("yes") : t("no")}
                    </b>
                  </div>
                  <Divider />
                  <div className={styles["mobile-box"]}>
                    <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {t("amarant:katData")}
                    </p>
                    <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          marginTop: "1%",
                        }}
                      >
                        <b
                          style={{
                            textDecoration: "underline",
                            color: "#0DC1CE",
                            cursor: "pointer",
                            fontSize: "15px",
                          }}
                          onClick={() => {
                            setOpenModal(true);
                            setCurrentVehicle(vehicle);
                          }}
                        >
                          {t("amarant:view")}
                        </b>
                        <div
                          className={styles["info-icon"]}
                          style={{ marginLeft: "2%", marginRight: "5%" }}
                          onClick={() => {
                            setOpenModal(true);
                            setCurrentVehicle(vehicle);
                          }}
                        />
                      </div>
                    </b>
                  </div>
                  <Divider />
                  <div className={styles["mobile-box"]}>
                    <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {t("amarant:scannedTalon")}
                    </p>
                    {vehicle?.pictures?.length > 0 ? (
                      <div
                        className={styles["data"]}
                        style={{
                          cursor: "pointer",
                          width: "100%",
                          alignItems: "center",
                          marginLeft: "0%",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            width: "100%",
                            marginTop: "1%",
                          }}
                        >
                          <b
                            style={{
                              textDecoration: "underline",
                              color: "#0DC1CE",
                              cursor: "pointer",
                              fontSize: "15px",
                            }}
                            onClick={() =>
                              fetchAndOpenPreSignedUrl(vehicle.pictures[0])
                            }
                          >
                            {t("amarant:view")}
                          </b>
                          <div
                            className={styles["info-icon"]}
                            style={{ marginLeft: "2%", marginRight: "5%" }}
                            onClick={() =>
                              fetchAndOpenPreSignedUrl(vehicle.pictures[0])
                            }
                          />
                        </div>

                        {vehicle?.pictures?.length > 1 && (
                          <div style={{ display: "flex", width: "100%" }}>
                            <b
                              style={{
                                textDecoration: "underline",
                                color: "#0DC1CE",
                                cursor: "pointer",
                                fontSize: "15px",
                              }}
                              onClick={() =>
                                fetchAndOpenPreSignedUrl(vehicle.pictures[1])
                              }
                            >
                              {t("amarant:view")}
                            </b>
                            <div
                              className={styles["info-icon"]}
                              style={{ marginLeft: "2%", marginRight: "5%" }}
                              onClick={() =>
                                fetchAndOpenPreSignedUrl(vehicle.pictures[1])
                              }
                            />
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className={styles["data"]}>---</div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </>
      ) : (
        // Desktop view
        <>
          <div className={styles["columns-container"]}>
            <div
              className={styles["upper-names"]}
              style={{
                width: window.innerWidth < 1400 ? "150%" : "100%",
              }}
            >
              {columnNames.map((column, i) => (
                <div
                  className={`${styles["name-icon"]}`}
                  key={i}
                  style={{
                    width: `${100 / columnNames.length}%`,
                    textAlign: "left",
                    paddingLeft: "2px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    if (filter === i.toString()) {
                      setFilter(`reverse${i}`);
                    } else {
                      setFilter(i.toString());
                    }
                  }}
                >
                  <p>{t(column)}</p>
                </div>
              ))}
            </div>
          </div>
          <div className={styles["tabs-container"]}>
            {vehicles.map((vehicle, i) => {
              const isArchived = isVehicleArchived(vehicle);

              return (
                <React.Fragment key={i}>
                  <div
                    className={styles["row-container"]}
                    style={{
                      width: window.innerWidth < 1400 ? "150%" : "100%",
                      minHeight: "50px",
                      height: "auto",
                    }}
                  >
                    <div
                      className={styles["data"]}
                      style={{
                        padding: "4px 0",
                        width: `${100 / columnNames.length}%`,
                        textAlign: "left",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        paddingLeft: "2px",
                      }}
                    >
                      <b style={{ textAlign: "left" }}>
                        {vehicle?.fullName
                          ? vehicle?.fullName
                          : vehicle?.companyName || ""}
                      </b>
                    </div>
                    <Divider
                      style={{
                        backgroundColor: "#D3D3D3",
                        height: "65%",
                      }}
                      orientation="vertical"
                    />
                    <div className={styles["data"]}>
                      <b>{vehicle?.licensePlate}</b>
                      {isArchived && (
                        <Tooltip title={t("amarant:archived")}>
                          <ArchiveIcon
                            fontSize="small"
                            style={{ marginLeft: "5px", color: "#999" }}
                          />
                        </Tooltip>
                      )}
                    </div>
                    <Divider
                      style={{
                        backgroundColor: "#D3D3D3",
                        height: "65%",
                      }}
                      orientation="vertical"
                    />
                    <div className={styles["data"]}>
                      <b>{vehicle?.certificateRegistration}</b>
                    </div>
                    <Divider
                      style={{
                        backgroundColor: "#D3D3D3",
                        height: "65%",
                      }}
                      orientation="vertical"
                    />
                    <div className={styles["data"]}>
                      <b>{vehicle?.carMakeEnglish.split(" ")[0]}</b>
                    </div>
                    <Divider
                      style={{
                        backgroundColor: "#D3D3D3",
                        height: "65%",
                      }}
                      orientation="vertical"
                    />
                    <div
                      className={styles["data"]}
                      style={{ whiteSpace: "normal" }}
                    >
                      <b>
                        {vehicle?.carMakeEnglish.includes(" ")
                          ? vehicle?.carMakeEnglish.slice(
                              vehicle?.carMakeEnglish.indexOf(" ") + 1
                            )
                          : vehicle?.carMakeEnglish}
                      </b>
                    </div>
                    <Divider
                      style={{
                        backgroundColor: "#D3D3D3",
                        height: "65%",
                      }}
                      orientation="vertical"
                    />
                    <div className={styles["data"]}>
                      <b>
                        {moment(vehicle?.createdAt).format(
                          "DD.MM.YYYY | HH:mm"
                        )}
                      </b>
                    </div>
                    <Divider
                      style={{
                        backgroundColor: "#D3D3D3",
                        height: "65%",
                      }}
                      orientation="vertical"
                    />
                    <div className={styles["data"]}>
                      <b>{vehicle.users.length > 0 ? t("yes") : t("no")}</b>
                      {vehicle.users.length > 0 && (
                        <div
                          className={styles["arrowDown"]}
                          id={`icon${i + 10}`}
                          onClick={() => {
                            setCurrentVehicle(vehicle);
                            rotateArrow(`icon${i + 10}`, `info${i}`);
                          }}
                        />
                      )}
                    </div>
                    <Divider
                      style={{
                        backgroundColor: "#D3D3D3",
                        height: "65%",
                      }}
                      orientation="vertical"
                    />
                    <div
                      className={styles["data"]}
                      onClick={() => {
                        setOpenModal(true);
                        setCurrentVehicle(vehicle);
                      }}
                    >
                      <b
                        style={{
                          textDecoration: "underline",
                          color: "#0DC1CE",
                          fontWeight: "bold",
                          cursor: "pointer",
                        }}
                      >
                        {t("amarant:view")}
                      </b>
                      <div className={styles["info-icon"]} />
                    </div>
                    <Divider
                      style={{
                        backgroundColor: "#D3D3D3",
                        height: "65%",
                      }}
                      orientation="vertical"
                    />
                    {vehicle?.pictures?.length > 0 ? (
                      <div
                        className={styles["data"]}
                        style={{ cursor: "pointer", width: "17%" }}
                      >
                        <b
                          style={{
                            textDecoration: "underline",
                            color: "#0DC1CE",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            fetchAndOpenPreSignedUrl(vehicle.pictures[0])
                          }
                        >
                          {t("amarant:view")}
                        </b>
                        <div
                          className={styles["info-icon"]}
                          style={{ marginLeft: "2%", marginRight: "5%" }}
                          onClick={() =>
                            fetchAndOpenPreSignedUrl(vehicle.pictures[0])
                          }
                        />
                        {vehicle?.pictures?.length > 1 && (
                          <>
                            <b
                              style={{
                                textDecoration: "underline",
                                color: "#0DC1CE",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                fetchAndOpenPreSignedUrl(vehicle.pictures[1])
                              }
                            >
                              {t("amarant:view")}
                            </b>
                            <div
                              className={styles["info-icon"]}
                              style={{ marginLeft: "2%", marginRight: "5%" }}
                              onClick={() =>
                                fetchAndOpenPreSignedUrl(vehicle.pictures[1])
                              }
                            />
                          </>
                        )}
                      </div>
                    ) : (
                      <div className={styles["data"]}>---</div>
                    )}
                  </div>
                  <div
                    className={`${styles["info-inner-tab"]}`}
                    id={`info${i}`}
                  >
                    <div
                      className={styles["columns-container"]}
                      style={{ marginTop: "-0.5%" }}
                    >
                      <div className={styles["upper-names"]}>
                        <div
                          className={`${styles["name-icon"]}`}
                          style={{ width: "12%", cursor: "pointer" }}
                          onClick={() => {
                            if (filter === "fullName") {
                              setFilter("reverseFullName");
                              filterByProp(
                                currentVehicle?.users,
                                "reversePlate",
                                "fullName"
                              );
                            } else {
                              setFilter("fullName");
                              filterByProp(
                                currentVehicle?.users,
                                "plate",
                                "fullName"
                              );
                            }
                          }}
                        >
                          <p>{t("amarant:colSharedWith")}</p>
                        </div>
                        <div
                          className={`${styles["name-icon"]}`}
                          style={{ width: "12%", cursor: "pointer" }}
                          onClick={() => {
                            if (filter === "phoneNumber") {
                              setFilter("reversePhoneNumber");
                              filterByProp(
                                currentVehicle?.users,
                                "reversePlate",
                                "phoneNumber"
                              );
                            } else {
                              setFilter("phoneNumber");
                              filterByProp(
                                currentVehicle?.users,
                                "plate",
                                "phoneNumber"
                              );
                            }
                          }}
                        >
                          <p>{t("amarant:colPhone")}</p>
                        </div>
                      </div>
                    </div>
                    <div className={styles["tabs-container"]}>
                      {currentVehicle?.users?.map((user, i) => {
                        return (
                          <div
                            className={styles["row-container"]}
                            style={{ height: "60px" }}
                            key={i}
                          >
                            <div
                              className={styles["data"]}
                              style={{ width: "12%" }}
                            >
                              <b>{user?.fullName}</b>
                            </div>
                            <Divider
                              style={{
                                backgroundColor: "#D3D3D3",
                                height: "65%",
                              }}
                              orientation="vertical"
                            />
                            <div
                              className={styles["data"]}
                              style={{ width: "12%" }}
                            >
                              <b>{user?.phoneNumber}</b>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </React.Fragment>
              );
            })}
          </div>
        </>
      )}

      {/* Vehicle details modal */}
      <VehicleModalComponent
        open={openModal}
        handleClose={() => setOpenModal(false)}
        currentVehicle={currentVehicle}
        mobileModal={window.innerWidth < 900 && true}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  vehicles: state.amarantFields.vehicles,
});

const mapDispatchToProps = (dispatch) => ({
  listVehicles: (payload) => dispatch(listVehicles(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(VehiclesComponent);
